import { Component, type ReactNode } from 'react';
import { Button, Result } from 'antd';

export class PageBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <Result status="error" title="页面暂时未能打开" subTitle="请刷新重试，或从导航进入其他页面。" extra={<Button onClick={() => window.location.reload()}>重新加载</Button>} /> : this.props.children;
  }
}
